document.addEventListener('DOMContentLoaded', function() {
  // Standard quantity inputs and elements
  const quantityInput = document.getElementById('quantity');
  const radioButtons = document.querySelectorAll('.v-bundle-input');
  const quantityIcons = document.querySelectorAll('.quantity-icon');
  const bundleItems = document.querySelectorAll('.v-bundle-item');
  const productQuantitySelector = document.querySelector('.product-quantity__selector');
  
  // Price display elements
  const productPriceOriginalElement = document.getElementById('p-calculated-original');
  const productPriceSaleElement = document.getElementById('p-calculated-sale'); 
  const savingsDifferenceElement = document.getElementById('difference');
  
  // Get the price from the data-update-block="price-extended" element
  const priceExtendedElement = document.querySelector('[data-update-block="price-extended"] .product-price--original');
  
  // Setup event listeners
  quantityIcons.forEach(icon => icon.addEventListener('click', handleQuantityIconClick));
  radioButtons.forEach(radio => radio.addEventListener('click', handleRadioButtonClick));
  if (quantityInput) {
    quantityInput.addEventListener('input', updateProductPrice);
  }

  // Function to get the current price from the price-extended block
  function getCurrentPrice() {
    // Get the latest price element (it might have been updated)
    const currentPriceElement = document.querySelector('[data-update-block="price-extended"] .product-price--original');
    
    if (!currentPriceElement) {
      console.error("Price element not found");
      return 0;
    }
    
    // Get the current price from the price-extended element
    const priceText = currentPriceElement.textContent.trim();
    console.log("Raw price text:", priceText);
    
    // Extract only the number part
    const price = parseFloat(priceText.replace(/[^\d.-]/g, ''));
    console.log("Parsed price:", price);
    
    return price || 0; // Return 0 if we couldn't parse a valid price
  }

  function handleQuantityIconClick(event) {
    const isPlus = event.target.id === 'plus';
    const currentValue = parseInt(quantityInput.value);
    quantityInput.value = isPlus ? currentValue + 1 : Math.max(currentValue - 1, 1);
    updateRadioButtons();
    updateCheckedStatus();
    updateProductQuantitySelectorValue();
    updateProductPrice();
  }

  function handleRadioButtonClick(event) {
    const clickedRadio = event.target;
    const clickedValue = parseInt(clickedRadio.value);
    radioButtons.forEach(radio => radio.checked = false);
    clickedRadio.checked = true;
    quantityInput.value = clickedValue;
    updateRadioButtons();
    updateCheckedStatus();
    updateProductQuantitySelectorValue();
    updateProductPrice();

    const quantity = parseInt(quantityInput.value);
    toggleElementsBasedOnQuantity(quantity);
  }

  function updateRadioButtons() {
    const currentValue = parseInt(quantityInput.value);
    radioButtons.forEach(radio => radio.checked = parseInt(radio.value) <= currentValue);
  }

  function updateCheckedStatus() {
    bundleItems.forEach(item => {
      const radioInput = item.querySelector('.v-bundle-input');
      const classList = item.classList;
      const optionRadio = item.querySelector('.option-radio');

      if (radioInput.checked) {
        classList.add('checked');
        optionRadio.classList.add('checked');
      } else {
        classList.remove('checked');
        optionRadio.classList.remove('checked');
      }
    });
  }

  function updateProductQuantitySelectorValue() {
    if (productQuantitySelector) {
      productQuantitySelector.value = quantityInput.value;
    }
  }

  function toggleElementsBasedOnQuantity(quantity) {
    const pPriceCardElement = document.getElementById('p-price-card');
    const pDiscountElement = document.getElementById('p-info-note');
    const differenceElement = document.getElementById('difference');

    if (quantity >= 2) {
      differenceElement.style.display = 'block';
      pDiscountElement.style.display = 'none';
      pPriceCardElement.style.opacity = 1;
    } else {
      differenceElement.style.display = 'none';
      pDiscountElement.style.display = 'block';
      pPriceCardElement.style.opacity = 0;
    }
  }

  function updateProductPrice() {
    // Get the current quantity
    const quantity = parseInt(quantityInput?.value || 1);
    
    // Get the current unit price from the price-extended element
    const originalUnitPrice = getCurrentPrice();
    
    // Calculate total original price
    const totalPriceOriginal = (quantity * originalUnitPrice).toFixed(2);
    
    // Update the original price display
    if (productPriceOriginalElement) {
      productPriceOriginalElement.textContent = `${totalPriceOriginal}`;
    }

    // Determine discount percentage based on quantity
    let discountPercentage = 0;
    if (quantity >= 4) {
      discountPercentage = 20;
    } else if (quantity >= 3) {
      discountPercentage = 15;
    } else if (quantity >= 2) {
      discountPercentage = 10;
    }

    // Calculate discounted price
    const discountedPrice = totalPriceOriginal * (1 - discountPercentage / 100);
    const salePrice = discountedPrice.toFixed(2);
    
    // Update sale price display
    if (productPriceSaleElement) {
      productPriceSaleElement.textContent = `${salePrice}`;
    }

    // Calculate and display savings
    const difference = (totalPriceOriginal - salePrice).toFixed(2);
    if (savingsDifferenceElement) {
      savingsDifferenceElement.textContent = `Du sparst CHF ${difference}`;
    }

    // Toggle visibility of elements based on quantity
    toggleElementsBasedOnQuantity(quantity);
    
    // Also update all the bundle item prices
    updateBundleItemPrices(originalUnitPrice);
  }
  
  // New function to update prices in bundle items
  function updateBundleItemPrices(currentPrice) {
    // Update original price displays in all bundle items
    document.querySelectorAll('.v-bundle-item .p-original').forEach(elem => {
      elem.textContent = `CHF ${currentPrice.toFixed(2)}`;
    });
    
    // Update discounted prices per item in all bundle options
    document.querySelectorAll('.v-bundle-item').forEach(item => {
      const bundleInput = item.querySelector('.v-bundle-input');
      const discountElem = item.querySelector('.p-item');
      if (bundleInput && discountElem) {
        let discount = 0;
        const value = parseInt(bundleInput.value);
        
        if (value >= 4) discount = 20;
        else if (value >= 3) discount = 15;
        else if (value >= 2) discount = 10;
        
        const discountedItemPrice = (currentPrice * (1 - discount / 100)).toFixed(2);
        discountElem.textContent = `CHF ${discountedItemPrice}/Stk.`;
      }
    });
  }

  // Initial price update
  updateProductPrice();
  
  // Watch for changes in the price-extended element to update calculations
  // This uses a MutationObserver to detect when the price changes on variant selection
  const priceObserver = new MutationObserver(function(mutations) {
    console.log("Price element changed, updating prices");
    
    // Get the current price from the updated element
    const currentPrice = getCurrentPrice();
    console.log("Current price detected:", currentPrice);
    
    // Update all bundle item prices with the new price
    updateBundleItemPrices(currentPrice);
    
    // Force recalculation of the output price based on current selection
    updateProductPrice();
  });
  
  // Start observing the price element for changes
  if (priceExtendedElement) {
    priceObserver.observe(document.querySelector('[data-update-block="price-extended"]'), { 
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true
    });
    
    // Initial update of all prices
    const currentPrice = getCurrentPrice();
    updateBundleItemPrices(currentPrice);
    updateProductPrice();
  }
});